export default __webpack_public_path__ + "img/c76933505518889e0eef38668d0e9972.svg";